import React from "react";
import "./ErrorPage.css"
import {Link} from 'react-router-dom'

const ErrorPage = () => {
    return (
        <div className="h-full w-full" id="error_page">
            <h1 id="test_title"> Error 404 Page Not Found</h1>
            <button class="favorite styled"
                type="button"
                id="homeButton">
            <Link to="/">Back to HOME</Link>
            </button>
            <div class="box">
                <p>The page you tried to reach is non existant</p>
            </div>
        </div>
    )
}

export default ErrorPage;